export const STORE_API_ERRORS: string = 'STORE_API_ERRORS',
  DELETE_API_ERROR: string = 'DELETE_API_ERROR',
  CONTEXT_CREATE: string = 'CONTEXT_CREATE',
  CONTEXT_DESTROY: string = 'CONTEXT_DESTROY';

export const STORE_SUCCESS_MESSAGE = 'STORE_SUCCESS_MESSAGE';

// getters
export const GET_ERRORS: string = 'getErrors';
